import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "antd";
import { useTranslate } from "@refinedev/core";
import { ArrowRightIcon } from "@phosphor-icons/react";

export type ViewChatHistoryLinkProps = {
  projectId: string;
};

/** "View history" link to the project's chat history page. */
export const ViewChatHistoryLink: React.FC<ViewChatHistoryLinkProps> = ({
  projectId,
}) => {
  const t = useTranslate();
  const navigate = useNavigate();
  const to = `/media/projects/${projectId}/chat-history`;

  return (
    <Typography.Link
      href={to}
      onClick={(event) => {
        // Cmd/Ctrl/Shift-click keeps the browser's "open in new tab/window".
        if (event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        navigate(to);
      }}
      style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
    >
      {t("media.components.ProjectSettingsDrawer.viewHistory")}
      <ArrowRightIcon size={12} />
    </Typography.Link>
  );
};
